import { AlpineComponent } from 'alpinejs';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

const SearchDialog = (): AlpineComponent => ({
  init() {
    this.$watch('$store.general.isSearchOpen', (isSearchOpen) => {
      if (isSearchOpen) {
        this.openDialog();
      } else {
        this.closeDialog();
      }
    });

    this.$root.addEventListener('close', () => {
      (this.$store as any).general.isSearchOpen = false;
    });
  },

  openDialog() {
    if (this.timeout) clearTimeout(this.timeout);
    disableBodyScroll(this.$refs.content);
    (this.$root as HTMLDialogElement).showModal();
  },

  closeDialog() {
    enableBodyScroll(this.$refs.content);
    this.timeout = setTimeout(() => {
      (this.$root as HTMLDialogElement).close();
    }, 300);
  }
});

export default SearchDialog;
